module.exports = __webpack_public_path__ + "img/saleIcon.a874fc11.png";